import Html from "./html";

class Epg {

    constructor(
        private html: Html
    ) { }

    load(epgId: number): void {
        this.html.fetchText('/epg/' + epgId)
            .then((html: string) => {
                const epgItem = this.html.q('#epg_item');
                if (!epgItem) {
                    return;
                }

                this.html.writeHTML(epgItem, html);
                this.html.addClass('#epg_item_holder .epg_item_wrapper', 'translate-y-0-imp');
                this.html.addClass('#epg_item_holder', 'epg-open');

                // update url, so that refresh shows the same epg item
                const url = document.location.pathname + '?e=' + epgId;
                history.pushState(null, "epg: " + epgId, url);
            });
    }

    close(): void {
        this.html.removeClass('#epg_item_holder .epg_item_wrapper', 'translate-y-0-imp');
        this.html.removeClass('#epg_item_holder', 'epg-open');

        const url = document.location.pathname;
        history.replaceState(null, "", url);
    }
}

export default Epg;